riot.tag2('bbc-notifications-onboarding-async', '<div class="spinner"> <img class="loader-icon notifications-image spinner__img--svg" riot-src="{this.parent.parent.opts.mainApp.basePath + \'/svg/loader.svg\'}" alt="Spinner"> </div>', '', '', function(opts) {
'use strict';

var _this = this;

this.on('mount', function () {
    _this.parent.parent.opts.mainApp.loadOnboarding(function (onboard) {
        var onboardOpts = {
            onboard: onboard,
            mainApp: _this.parent.parent.opts.mainApp,
            componentApp: _this.parent.parent.parent
        };
        riot.mount(_this.root, 'bbc-notifications-onboarding', onboardOpts);
    });
});
});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/components/bbc-notifications-onboarding-async.tag
 ** module id = 26
 ** module chunks = 0
 **/